var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4947 60.3486L86.8293 86.2617L83.2274 87.7563L77.7901 90.0281L72.3588 92.2998L63.1194 96.1409L60.9552 97.0377L35.0422 86.3813L24.2603 60.5071L34.9286 34.594L38.7368 33.0038L47.9703 29.1627L53.4046 26.8969L58.8359 24.6311L60.8028 23.8121L86.7098 34.4744L97.4947 60.3486Z",
    fill: "url(#paint0_linear_3288_1553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8027 23.8121L60.7549 0.436829L103.21 17.9205L86.7187 34.4804L60.8027 23.8121Z",
    fill: "url(#paint1_linear_3288_1553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8028 23.8121L34.9287 34.591L18.3718 18.0968L60.755 0.439819L60.8028 23.8121Z",
    fill: "url(#paint2_linear_3288_1553)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9286 34.591L24.2603 60.5041L0.888123 60.5579C0.888123 60.5579 0.888123 60.534 0.921003 60.4832L18.3687 18.0968L34.9286 34.591Z",
    fill: "url(#paint3_linear_3288_1553)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9286 34.591L24.2603 60.5041L0.888123 60.5579C0.888123 60.5579 0.888123 60.534 0.921003 60.4832L18.3687 18.0968L34.9286 34.591Z",
    fill: "url(#paint4_linear_3288_1553)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9286 34.591L24.2603 60.5041L0.888123 60.5579C0.888123 60.5579 0.888123 60.534 0.921003 60.4832L18.3687 18.0968L34.9286 34.591Z",
    fill: "url(#paint5_linear_3288_1553)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0422 86.3783L18.5481 102.941L18.4943 102.813L0.888123 60.5579L24.2574 60.5041L35.0422 86.3783Z",
    fill: "url(#paint6_linear_3288_1553)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5067 60.3546L120.879 60.3068L103.219 17.9235L86.7248 34.4834L97.5067 60.3546Z",
    fill: "url(#paint7_linear_3288_1553)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5066 60.3546L86.8353 86.2707L103.398 102.765L120.879 60.3068L97.5066 60.3546Z",
    fill: "url(#paint8_linear_3288_1553)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8354 86.2706L103.398 102.765L61.012 120.425L60.9642 97.0525L86.8354 86.2706Z",
    fill: "url(#paint9_linear_3288_1553)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.039 86.3783L18.5478 102.938L61.0058 120.422L60.958 97.0496L35.039 86.3783Z",
    fill: "url(#paint10_linear_3288_1553)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.888123 60.5579L24.2574 60.5041C5.92784 68.8977 17.6274 100.517 18.4943 102.813L0.888123 60.5579Z",
    fill: "url(#paint11_linear_3288_1553)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.7553 0.439819V9.8258C37.4399 6.88148 34.929 34.591 34.929 34.591C13.706 32.935 1.63879 58.9049 0.924377 60.4832L18.3721 18.0968L60.7553 0.439819Z",
    fill: "url(#paint12_linear_3288_1553)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.006 120.422C61.006 120.422 32.0889 108.205 35.0422 86.3783L18.4942 102.819L61.006 120.422Z",
    fill: "url(#paint13_linear_3288_1553)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M86.7247 34.4834C86.7247 34.4834 63.4302 23.0439 69.8359 4.17626L60.7549 0.436829L60.8027 23.8121L86.7247 34.4834Z",
    fill: "url(#paint14_linear_3288_1553)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0058 120.422L103.398 102.765L120.879 60.3068L103.219 17.9235L118.801 60.3068L101.999 101.635L61.0058 120.422Z",
    fill: "url(#paint15_linear_3288_1553)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.9701 97.0496L35.0422 86.3813L24.2603 60.5071L34.9286 34.594L38.7368 33.0038L47.9703 29.1627L53.4046 26.8969L58.8359 24.6311L60.8028 23.8121L86.7098 34.4744C22.6432 23.6028 60.9701 97.0496 60.9701 97.0496Z",
    fill: "url(#paint16_linear_3288_1553)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7661 31.0787C75.8354 29.3211 70.4071 26.9686 63.9236 24.2036C63.2575 23.9192 62.688 23.4481 62.2838 22.8471C61.8797 22.2461 61.6581 21.541 61.6458 20.8169C61.5562 15.2182 61.4366 10.4534 61.2991 6.94118C61.1347 2.82211 60.9434 0.424805 60.7461 0.424805C60.5488 0.424805 60.3635 2.81614 60.22 6.94417C60.0945 10.4325 59.9958 15.1584 59.9211 20.6943C59.9129 21.4283 59.6889 22.1437 59.277 22.7513C58.865 23.3588 58.2834 23.8317 57.6045 24.1109C52.6186 26.1555 43.2326 30.0444 38.175 32.1399C37.2473 32.5237 36.2277 32.628 35.2415 32.44C34.2553 32.252 33.3455 31.7799 32.6241 31.0817C28.9863 27.5545 25.8178 24.5653 23.4026 22.3234C20.3626 19.5226 18.5243 17.9503 18.3688 18.0967C18.2134 18.2432 19.8036 20.0845 22.6164 23.1126C24.8553 25.5039 27.8803 28.6754 31.4404 32.3252C32.1419 33.0438 32.6178 33.952 32.8095 34.9378C33.0013 35.9235 32.9004 36.9439 32.5195 37.8731C30.4809 42.8709 26.6667 52.1433 24.67 57.0575C24.3628 57.8119 23.8405 58.4592 23.1682 58.919C22.4958 59.3787 21.7031 59.6306 20.8887 59.6431C15.4903 59.7298 10.869 59.8464 7.43749 59.9869C3.30348 60.1513 0.888245 60.3486 0.888245 60.5549C0.888245 60.7611 3.30647 60.9494 7.43749 61.0989C10.8989 61.2214 15.568 61.323 21.0232 61.3978C21.8271 61.4048 22.6117 61.6445 23.2822 62.088C23.9527 62.5315 24.4804 63.1597 24.8015 63.8967C27.5336 70.2397 29.8831 75.5545 31.6168 79.4404C33.6404 83.9241 34.8809 86.453 35.0513 86.3842C35.2217 86.3155 34.2921 83.6461 32.5374 79.0548C31.1116 75.3243 29.1388 70.3204 26.7594 64.4079C25.7798 61.9698 25.7959 59.2447 26.8042 56.8184C28.8189 51.9819 31.9815 44.3326 33.9782 39.5141C35.0811 36.8433 37.1975 34.7183 39.8639 33.6045C44.6465 31.5988 52.227 28.4243 57.1322 26.3528C59.5462 25.3353 62.2634 25.3074 64.6978 26.2751C70.6342 28.6335 75.656 30.5915 79.4014 32.0053C84.0018 33.7391 86.6711 34.6567 86.7398 34.4863C86.8086 34.316 84.2528 33.0844 79.7661 31.0787Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.0944 14.8506C35.5922 13.7087 32.9737 13.7536 30.2476 14.9492C27.5215 16.1449 25.7131 18.043 26.2123 19.1849C26.7115 20.3267 29.3329 20.2819 32.0591 19.0862C34.7852 17.8906 36.5936 15.9925 36.0944 14.8506Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M62.5362 28.9116C61.8547 27.3543 58.2826 27.4171 54.5581 29.0462C50.8336 30.6753 48.3706 33.2669 49.0551 34.8242C49.7396 36.3816 53.3116 36.3188 57.0331 34.6897C60.7546 33.0606 63.2207 30.472 62.5362 28.9116Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.7437 35.6611C41.8815 36.4772 40.65 37.7715 40.9907 38.5516C41.3315 39.3318 43.119 39.3019 44.9813 38.4829C46.8435 37.6639 48.075 36.3725 47.7343 35.5954C47.3935 34.8182 45.606 34.8451 43.7437 35.6611Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3288_1553",
    x1: 136.155,
    y1: 135.827,
    x2: 36.4427,
    y2: 29.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F0018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B60018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3288_1553",
    x1: 116.694,
    y1: 57.0422,
    x2: 115.408,
    y2: 0.642463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1D36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3288_1553",
    x1: 278.862,
    y1: 250.416,
    x2: 83.8952,
    y2: -58.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F0018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B60018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3288_1553",
    x1: 94.5257,
    y1: 96.1783,
    x2: -7.11512,
    y2: 77.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67CD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3288_1553",
    x1: 26.2933,
    y1: 63.6482,
    x2: -98.0263,
    y2: -22.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3288_1553",
    x1: 98.8938,
    y1: 128.537,
    x2: -4.08688,
    y2: 43.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A01D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D61D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1D36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3288_1553",
    x1: 93.2198,
    y1: 161.834,
    x2: -61.5781,
    y2: 93.5537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F0018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B60018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3288_1553",
    x1: 307.652,
    y1: 140.022,
    x2: -18.2032,
    y2: 30.7184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3288_1553",
    x1: 137.939,
    y1: 106.574,
    x2: 30.86,
    y2: 68.3264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3288_1553",
    x1: 92.6337,
    y1: 122.911,
    x2: 105.576,
    y2: 66.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3288_1553",
    x1: 132.18,
    y1: 218.876,
    x2: 40.2641,
    y2: 23.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3288_1553",
    x1: 101.462,
    y1: 16.4207,
    x2: -50.6874,
    y2: -18.3399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3288_1553",
    x1: 114.494,
    y1: 106.246,
    x2: -33.0727,
    y2: -39.0068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3288_1553",
    x1: 100.532,
    y1: 24.3327,
    x2: -74.2329,
    y2: 266.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3288_1553",
    x1: 60.7549,
    y1: 59.319,
    x2: 67.0613,
    y2: -24.3645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3288_1553",
    x1: 84.3607,
    y1: 185.784,
    x2: 28.9943,
    y2: 45.8987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#610007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F20007"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3288_1553",
    x1: 107.516,
    y1: 117.335,
    x2: 24.7819,
    y2: 74.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.27
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.2672303391f181b11cfdb8e7b350de06.svg";
export { ForwardRef as ReactComponent };